<main class="page-main">
	<app-page-sub-nav [data]="pageSubNavData" [currVisible]="currVisible"></app-page-sub-nav>
	<section class="page-section" id="overview">
		<h2 id="sectionTitleOverview" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('overview')">
			Overview <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<app-external-resource [componentName]="'Date Picker'" [includeDescription]="true"
			[otherNames]="true"></app-external-resource>
	</section>
	<section class="page-section" id="example">
		<h2 id="sectionTitleExample" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('example')">
			Live example <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>

		<form class="example-container k-body" [formGroup]="form">
			<div class="page-live-header">
				<select title="Change Example" class="page-live-example-select" (change)="changeCurrLive($event)">
					<option value="default">Default</option>
					<option value="disabled">Disabled</option>
				</select>
				<app-theme-switcher></app-theme-switcher>
			</div>
			<div class="page-live-example-content">
				<form class="k-form" [formGroup]="form">
					<kendo-formfield>
						<kendo-label [for]="birthDate" text="Birth Date"></kendo-label>
						<kendo-datepicker #birthDate required formControlName="birthDate" [disabled]="disabled"
							[(ngModel)]="dateValue" [format]="format" [adaptiveMode]="adaptiveMode" [min]="dateMin"
							[max]="dateMax" (blur)="validateDate()" (open)="validateDate()"
							(valueChange)="validateDate()" [incompleteDateValidation]="true">
							<ng-template kendoCalendarNavigationItemTemplate let-title let-date="date"
								let-view="activeView">
								{{ view === "month" && date.getMonth() === 0 ? "Jan" : title }}
							</ng-template>
						</kendo-datepicker>
						<kendo-formhint>Choose a date between {{ birthDate.min | date:'MM/dd/yyyy' }} and {{
							birthDate.max | date:'MM/dd/yyyy' }}.</kendo-formhint>
						<kendo-formerror *ngIf="dateControl.errors?.incompleteDate">
							Birth date must not be incomplete.
						</kendo-formerror>
						<kendo-formerror *ngIf="!dateControl.errors?.incompleteDate && dateControl.errors?.required">
							Birth date is required. Enter a date.
						</kendo-formerror>
						<kendo-formerror *ngIf="dateControl.errors?.minError || dateControl.errors?.maxError">
							The selected date should be between {{ birthDate.min | date:'MM/dd/yyyy' }} and {{
							birthDate.max | date:'MM/dd/yyyy' }}.
						</kendo-formerror>
					</kendo-formfield>
				</form>
			</div>
		</form>

	</section>
	<section class="page-section" id="dev">
		<h2 id="sectionTitleDev" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('dev')">
			Developer resources <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="dev-code">
			<h3 id="subSectionTitleDevCode" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-code')">
				Code examples <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<pre prism class="dark">{{datePickerHTML}}</pre>
			<pre prism class="dark">{{datePickerTS}}</pre>
		</section>
	</section>
	<section class="page-section" id="styles">
		<h2 id="sectionTitleStyles" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('styles')">
			Styles <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-section-list">
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (light theme)
					</summary>

					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefault" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Primary text button (current month text)</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultPrimary" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Secondary text button ("today" text)</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultSecondary" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (dark theme)
					</summary>

					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDark" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Primary text button (current month text)</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkPrimary" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Secondary text button ("today" text)</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkSecondary" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Typography</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTypography" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Text field</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTextFieldTypography" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Primary and secondary text button</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesButtonTextTypography" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Structure</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesStructure" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Text Input</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTextInputStructure" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Primary and secondary text button</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesButtonTextStructure" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
		</ul>
	</section>
	<section class="page-section" id="behaviors">
		<h2 id="sectionTitleBehaviors" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('behaviors')">
			Behaviors <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="behaviors-focus">
			<h3 id="sectionTitleBehaviorsFocus" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-focus')">
				Focus <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					A focus state replaces the browser default focus state for date pickers. The border also
					changes color on focus.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-text-field">
			<h3 id="sectionTitleBehaviorsTextField" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-text-field')">
				Text field <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Users enter a value by typing in the text field. Date pickers use input masks that
					only allow for characters that match what is expected. A date picker should tell the
					user what the expected date format is.
				</li>
				<li class="page-section-list-item">
					A calendar <a href="components/icon">icon</a> is inside the text box to the right to show it's a
					date picker.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-calendar-popup">
			<h3 id="sectionTitleBehaviorsCalendarPopup" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-calendar-popup')">
				Calendar pop-up <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Selecting the calendar icon inside the text field opens a pop-up that allows users to pick a date.
					Users can choose the month and year using the lefthand menu, or by selecting the header. There is
					also a <a href="components/button">text button</a> <strong> Today</strong> that inputs the current
					date.
				</li>

				<li class="page-section-list-item">
					A filled circle indicates the selected day. The current date is selected by default. Once the user
					picks a date, the pop-up closes. When re-opened, today’s date is a different color if the user chose
					another day.
				</li>
				<li class="page-section-list-item">
					The calendar does not allow users to select a date outside the range that the date picker
					was configured for.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-masking">
			<h3 id="sectionTitleBehaviorsMasking" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-masking')">
				Input masking <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					When typing in the date picker, each section of the value has an input mask to prevent characters
					that don't match the expected format. The date picker allows only numbers. For example, users must
					type 1 or 01 for January.
				</li>
				<li class="page-section-list-item">
					After a user completes a section, focus should jump to the next section. For example, when a user
					enters a month the focus jumps to the day, then the year.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-error">
			<h3 id="sectionTitleBehaviorsError" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-error')">
				Error <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Error states in a date picker change the color of the border and displays an error message
					below the field. When the error condition is fixed, the border returns to normal and the error
					message is immediately removed.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-disabled">
			<h3 id="sectionTitleBehaviorsDisabled" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-disabled')">
				Disabled <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					When disabled, the date picker field is displayed
					at 50% opacity. The field and icons cannot be clicked, focused, or interacted with in any way.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-help-text">
			<h3 id="sectionTitleBehaviorsHelpText" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-help-text')">
				Help text <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Date picker labels can give extra context or instructions using a <a
						href="components/help-text">help text component</a>. This
					appears as a question mark icon to the right of the label.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-instructional-text">
			<h3 id="subSectionTitleBehaviorsInstructionalText" class="page-sub-section-title"
				title="Copy Link to Clipboard" (click)="copyToClipboard('behaviors-instructional-text')">
				Instructional text <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Instructional text appears below the date picker. It should
					only be used for very short messages. If more instruction is needed, use <a
						href="components/help-text">help text</a>.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="variations">
		<h2 id="sectionTitleVariations" class="page-section-title page-section-title-empty"
			title="Copy Link to Clipboard" (click)="copyToClipboard('variations')">
			Variations <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-section-content">
			There are no variations for this component.
		</section>
	</section>
	<section class="page-section" id="usage">
		<h2 id="sectionTitleUsage" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('usage')">
			Usage guidelines <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="usage-date-format">
			<h3 id="subSectionTitleUsageDateContent" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-date-format')">
				Date format <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					As outlined in <a href="guidelines/formatting">the formatting guidelines</a>, date pickers
					follow a "month/day/year" format. After entering a valid date with that format, the text
					field should translate it to a more legible state that is easier to scan and understand.
					Focusing on the text field returns it to the original format to make editing easier.
				</li>
				<li class="page-section-list-item">
					Example: 01/03/2002 would be changed to January 3, 2022.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-content">
			<h3 id="subSectionTitleUsageContent" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-content')">
				Content <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Label</span>
					A date picker label should be short — no more than a few words. The label
					should indicate what will happen on the date the user selects.
				</li>
				<li class="page-section-list-item">
					<ul class="page-section-comparison-list">
						<li class="page-section-comparison-list-item comparison-do">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="doThisIcon"></kendo-svg-icon>
								Try This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Start Day
									</li>
									<li class="comparison-body-text-list-item">
										Scan Date
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Instructional Text</span>
					You can give more guidance in instructional text, like the earliest and latest date. This helps
					prevent errors.
				</li>
				<li class="page-section-list-item">
					<ul class="page-section-comparison-list">
						<li class="page-section-comparison-list-item comparison-do">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="doThisIcon"></kendo-svg-icon>
								Try This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Choose a date after January 1, 1990.
									</li>
									<li class="comparison-body-text-list-item">
										Choose a date between 1/1/1900 and 12/31/2099.
									</li>
									<li class="comparison-body-text-list-item">
										Choose a date before December 31, 2099.

									</li>
								</ul>
							</div>
						</li>
					</ul>
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Help Text</span>
					If there are longer instructions that could give users more context, use <a
						href="components/help-text">help text</a>. Don’t use help
					text for information that the user needs to know to be successful, like the format.
				</li>
				<li class="page-section-list-item">
					<ul class="page-section-comparison-list">
						<li class="page-section-comparison-list-item comparison-do">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="doThisIcon"></kendo-svg-icon>
								Try This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										This is the date the next batch of computers will update.
									</li>
								</ul>
							</div>
						</li>
						<li class="page-section-comparison-list-item comparison-do-not">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="xMarkIcon"></kendo-svg-icon>
								Not this
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Month/Day/Year
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Error Message</span>
					Error text appears below the date picker. The message should be short, but it can wrap if it's wider
					than the field. It should be
					concise and jargon-free. Be specific to what went wrong and tell the user how to move forward.
				</li>
				<li class="page-section-list-item">
					<ul class="page-section-comparison-list">
						<li class="page-section-comparison-list-item comparison-do">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="doThisIcon"></kendo-svg-icon>
								Try This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										You need to pick a date after 1/1/1900.
									</li>
									<li class="comparison-body-text-list-item">
										You can't pick a date after December 31, 2099.
									</li>
									<li class="comparison-body-text-list-item">
										The selected date must be between 01/01/2023 and 12/31/2023.
									</li>
								</ul>
							</div>
						</li>
						<li class="page-section-comparison-list-item comparison-do-not">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="xMarkIcon"></kendo-svg-icon>
								Not this
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Oops! Try again.
									</li>
									<li class="comparison-body-text-list-item">
										Error. Could not validate entry.
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="related">
		<h2 id="sectionTitleRelated" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('related')">
			Related <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<span class="page-related-list-title">Referenced in this section:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
				<a href="components/button">Button component</a>
			</li>
			<li class="page-related-list-item">
                <a href="guidelines/colors">Colors guidelines</a>
            </li>
			<li class="page-related-list-item">
				<a href="guidelines/formatting">Formatting guidelines</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/help-text">Help text component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/icon">Icon component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/text-field">Text field component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/time-picker">Time picker component</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/typography">Typography guidelines</a>
			</li>
		</ul>
	</section>
	<section class="page-section" id="history">
		<h2 id="sectionTitleHistory" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('history')">
			Revision history
			 <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-history-list">
			<li class="page-history-list-item"
				*ngFor="let subItem of changelogService.getChangelogBySection('Date Picker Component')">
				<span class="page-history-list-item-title">
					{{ changelogService.formatDate(subItem.changeDate) }}</span>
				<a class="page-history-list-item-link" target="_blank" *ngIf="subItem.workId != ''" [attr.href]="
						'https://beyondtrust.atlassian.net/jira/software/c/projects/SDS/issues/' +
						subItem.workId">
					[{{ subItem.workId }}]
				</a>{{ subItem.changeName }}
			</li>
		</ul>
	</section>
</main>
